export default __webpack_public_path__ + "static/media/editAccountGreen.2b02c142.svg";